import { ErrorHandler, Injectable } from "@angular/core";
import { IApiError } from "@models/http/http-options";
import { TranslateService } from "@ngx-translate/core";
import { ApplicationInsightsService } from "./application-insights.service";


@Injectable({
  providedIn: "root",
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private readonly translateService: TranslateService,
    private readonly appInsightsService: ApplicationInsightsService
  ) {}

  handleError(error: any) {
    try {
      this.appInsightsService.logException(error instanceof Error ? error : new Error(error));
    } catch (e) {
      console.warn("Application Insights logging failed:", e);
    }
  }

  getErrorMessage(error: IApiError): string {
    if (!error) {
      return "";
    }

    const property = error.property
      ? `: ${this.translateService.instant(error.property)}`
      : "";

    return (
      this.translateService.instant(error.code || "unexpected.error") + property
    );
  }
}
